import { ITableDataSourceItem } from "@/Common/Models/UI/Tables/ITableDataSourceItem";
import { PatientCommunicationsItem } from "./PatientCommunicationsItem";

class PatientCommunicationsListItem implements ITableDataSourceItem<PatientCommunicationsItem> {
    public Model: PatientCommunicationsItem;
    public Name: string;

    constructor(model: PatientCommunicationsItem) {
        this.Model = model;
    }
}

export { PatientCommunicationsListItem };
